<div *ngIf="data"  class="detail-content">
    <mat-form-field class="example-full-width">
        <mat-label>GDPR Header</mat-label>
        <input matInput placeholder="Description"[(ngModel)]="data.gdprHeader">
    </mat-form-field>
    <mat-form-field class="example-full-width">
        <mat-label>GDPR Text</mat-label>
        <textarea  matInput placeholder="Description"[(ngModel)]="data.gdprText" rows="24"></textarea>
    </mat-form-field>
</div>